import React from 'react';
import { painClose, painIntro, painPoints } from '../data/painPoints';
import { OFFER_ANCHOR } from './constants';
export function PainSection() {
  return <section className="border-y border-eq-line bg-eq-light px-3 py-3 sm:px-4 sm:py-4" data-id="element-86" data-mp="38vu684fcdz20">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="2uxvy3grm6yuy">
        <h2 className="mb-1 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-88" data-mp="2yz7ovpm85q4q">
          Does This Sound Familiar?
        </h2>
        <div className="mx-auto mb-2 max-w-3xl space-y-0.5 text-center text-[12.5px] font-medium leading-snug text-eq-muted sm:text-base" data-id="element-89" data-mp="2pz2h3ed4cpq1">
          {painIntro.map(line => <p key={line} data-id="element-90" data-mp="2b83bmc7kyhao">{line}</p>)}
          <p className="font-bold text-eq-navy" data-id="element-91" data-mp="2g8pvrjxhcsiu">{painClose}</p>
        </div>

        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-92" data-mp="229hv0mlo5ccj">
          {painPoints.map(point => <a key={point.title} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border-l-4 border-eq-gold bg-white p-2.5 shadow-sm transition-colors duration-150 ease-out hover:bg-eq-light sm:p-3" data-id="element-93" data-mp="278bd6sbwhrj1">
              <h3 className="mb-0.5 font-display text-[13px] font-extrabold uppercase leading-tight text-eq-navy sm:text-lg" data-id="element-94" data-mp="3nl5vup9f4wxm">
                {point.title}
              </h3>
              {point.lines.map(line => <p key={line} className="text-[12px] font-medium leading-snug text-eq-muted sm:text-sm" data-id="element-95" data-mp="ewnics61f9f">
                  {line}
                </p>)}
            </a>)}
        </div>
      </div>
    </section>;
}